// extracted by mini-css-extract-plugin
module.exports = {"button":"StatusBarButton-StatusBarButton-button-3kuvb8CL"};